import PropTypes from "prop-types";

// @mui material components
import { Grid } from "@mui/material";
import { Controller } from "react-hook-form";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import MDButton from "../../../../../components/MDButton";

import FormField from "../FormField";

function AdInfo({ control, errors }) {

  return (
    <MDBox>
      <MDTypography variant="h5" mb={3}>
        Sobre el anuncio
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Controller
            name="title"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Título"
                error={!!errors.title}
                helperText={errors.title?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Descripción"
                error={!!errors.description}
                helperText={errors.description?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="image"
            control={control}
            render={({ field }) => (
              <MDBox mb={2}>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  Image
                </MDTypography>
                {field.value && (
                  <MDBox mt={2} mb={2}>
                    <img src={field.value} alt="Imagen" style={{ width: "100%", maxHeight: "200px", objectFit: "contain", borderRadius: "8px" }} />
                  </MDBox>
                )}
                <input
                  id="logo-upload-input"
                  style={{ display: "none" }}
                  accept="image/*"
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        field.onChange(reader.result);
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />
                <MDButton
                  variant="outlined"
                  color="info"
                  fullWidth
                  onClick={() => document.getElementById("logo-upload-input").click()}
                >
                  Subir Imagen
                </MDButton>
                {errors.image && (
                  <MDTypography variant="caption" color="error">
                    {errors.image.message}
                  </MDTypography>
                )}
              </MDBox>
            )}
          />
        </Grid>

      </Grid>
    </MDBox>
  );
}

AdInfo.propTypes = {
  control: PropTypes.isRequired,
  errors: PropTypes.isRequired,
};

export default AdInfo;
